import { render, staticRenderFns } from "./ReportRatings.vue?vue&type=template&id=94809cda&scoped=true"
import script from "./ReportRatings.vue?vue&type=script&lang=js"
export * from "./ReportRatings.vue?vue&type=script&lang=js"
import style0 from "./ReportRatings.vue?vue&type=style&index=0&id=94809cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94809cda",
  null
  
)

export default component.exports